<template>
  <v-container fluid class="px-0 protocolos-container" id="listado-consultas">

    <!-- Toolbar -->
    <div class="toolbar">
      <div class="toolbar-left">
        <button class="btn-toolbar btn-secondary" @click="openImportModal">
          <v-icon size="14">mdi-import</v-icon>
          <span>Importar Protocolos</span>
        </button>

        <div class="search-wrapper">
          <v-icon class="search-icon" size="15" color="#9ca3af">mdi-magnify</v-icon>
          <input
            v-model="searchProtocolo"
            type="text"
            class="search-input"
            placeholder="Buscar protocolos..."
            @input="onSearch"
          />
          <button v-if="searchProtocolo" class="clear-search" @click="searchProtocolo = ''">
            <v-icon size="13" color="#9ca3af">mdi-close</v-icon>
          </button>
        </div>
      </div>

      <div class="toolbar-right">
        <span class="results-label">{{ filteredProtocolos.length }} protocolo{{ filteredProtocolos.length !== 1 ? 's' : '' }}</span>
        <button
          class="btn-toolbar btn-primary"
          @click="$store.entregaStore.commit('setCreateProtocoloModal', true)"
        >
          <v-icon size="14" color="white">mdi-note-plus</v-icon>
          <span>Agregar</span>
        </button>
      </div>
    </div>

    <!-- Table header -->
    <div class="table-header">
      <div class="col-etapa">Etapa</div>
      <div class="col-title">Nombre del Protocolo</div>
      <div class="col-actions"></div>
    </div>

    <!-- Protocol rows -->
    <div class="protocols-list">
      <!-- Empty state -->
      <div v-if="filteredProtocolos.length === 0" class="empty-state">
        <v-icon size="40" color="#d1d5db">mdi-clipboard-text-search-outline</v-icon>
        <p class="empty-title">Sin protocolos</p>
        <p class="empty-sub">
          {{ searchProtocolo ? 'No se encontraron coincidencias para tu búsqueda' : 'Aún no hay protocolos en este proyecto' }}
        </p>
      </div>

      <div
        v-for="(plano, index) in filteredProtocolos"
        :key="index"
        class="protocol-row"
        @click.stop="viewPlano(plano.id)"
      >
        <div class="col-etapa">
          <span class="etapa-badge">{{ plano.etapa }}</span>
        </div>
        <div class="col-title">
          <span class="protocol-title">{{ plano.title }}</span>
        </div>
        <div class="col-actions" @click.stop>
          <button class="btn-edit" @click.stop="editProtocolo(plano)">
            <v-icon size="13">mdi-pencil</v-icon>
            <span>Editar</span>
          </button>
        </div>
      </div>
    </div>

    <!-- Pagination -->
    <div class="pagination-wrapper" v-if="$store.entregaStore.state.listadoEntregaTotal > 50">
      <v-pagination
        v-model="page"
        color="#2D4B95"
        :length="Math.ceil($store.entregaStore.state.listadoEntregaTotal / 50)"
        :total-visible="7"
        @input="changePlanoPage"
      ></v-pagination>
    </div>

    <!-- Modal editar protocolo -->
    <edit-protocolo-modal
      :closeModal="closeEditModal"
      :modalStatus="editModalStatus"
      :protocoloToEdit="selectedProtocolo"
    ></edit-protocolo-modal>

    <!-- Modal importar protocolos -->
    <importar-protocolos-modal
      :closeModal="closeImportModal"
      :modalStatus="importModalStatus"
    ></importar-protocolos-modal>
  </v-container>
</template>

<script>
import EditProtocoloModal from '@/components/Globals/Modals/Entrega/EditProtocoloModal.vue';
import ImportarProtocolosModal from '@/components/Globals/Modals/Entrega/ImportarProtocolosModal.vue';

export default {
  name: 'Protocolos',
  components: {
    EditProtocoloModal,
    ImportarProtocolosModal
  },
  data: () => ({
    loading: false,
    page: 1,
    editModalStatus: false,
    selectedProtocolo: null,
    importModalStatus: false,
    searchProtocolo: ''
  }),
  mounted() {
    this.loadProtocolos();
  },
  computed: {
    filteredProtocolos() {
      let protocolos = this.$store.entregaStore.state.listadoProtocolos.data || [];
      if (!this.searchProtocolo || !this.searchProtocolo.trim()) {
        return protocolos.sort((a, b) => a.title.localeCompare(b.title));
      }
      const search = this.searchProtocolo.toLowerCase();
      return protocolos.filter(p =>
        p.title.toLowerCase().includes(search) || p.etapa.toLowerCase().includes(search)
      ).sort((a, b) => a.title.localeCompare(b.title));
    }
  },
  methods: {
    onSearch() {
      this.page = 1;
    },

    loadProtocolos() {
      const projectID = this.$store.projectsStore.state.selectedProject.id;
      this.$store.entregaStore.dispatch('getProtocolos', {
        project_id: projectID,
        page: this.page
      });
    },

    changePlanoPage(page) {
      this.page = page;
      this.loadProtocolos();
    },

    viewPlano(id) {
      console.log('Ver detalles del protocolo:', id);
    },

    async editProtocolo(protocolo) {
      try {
        this.selectedProtocolo = protocolo;
        this.editModalStatus = true;
      } catch (error) {
        console.error('Error al cargar el protocolo para edición:', error);
        this.$store.globalStore.dispatch('addMessage', {
          message: 'Error al cargar el protocolo para edición',
          title: 'Error',
          created: new Date(),
          type: 'error',
          icon: 'mdi-alert-circle',
          color: '#fb8c00'
        });
      }
    },

    closeEditModal() {
      this.editModalStatus = false;
      this.selectedProtocolo = null;
      this.loadProtocolos();
    },

    openImportModal() {
      this.importModalStatus = true;
    },

    closeImportModal() {
      this.importModalStatus = false;
      this.loadProtocolos();
    }
  }
};
</script>

<style scoped>
.protocolos-container {
  font-family: inherit;
}

/* Toolbar */
.toolbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 14px 0;
  gap: 12px;
  flex-wrap: wrap;
}

.toolbar-left,
.toolbar-right {
  display: flex;
  align-items: center;
  gap: 10px;
}

.results-label {
  font-size: 12px;
  color: #94a3b8;
}

/* Toolbar buttons */
.btn-toolbar {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  height: 32px;
  padding: 0 14px;
  border-radius: 7px;
  font-size: 12px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.15s;
  border: none;
  white-space: nowrap;
}

.btn-secondary {
  background: #fff;
  border: 1px solid #e2e8f0;
  color: #475569;
}
.btn-secondary:hover {
  background: #f8fafc;
  border-color: #cbd5e1;
  color: #2D4B95;
}

.btn-primary {
  background: linear-gradient(135deg, #5e85ef, #3d6de0);
  color: #fff;
  box-shadow: 0 1px 4px rgba(94, 133, 239, 0.3);
}
.btn-primary:hover {
  transform: translateY(-1px);
  box-shadow: 0 3px 8px rgba(94, 133, 239, 0.4);
}

/* Search */
.search-wrapper {
  display: flex;
  align-items: center;
  gap: 7px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 0 10px;
  height: 32px;
  width: 260px;
  transition: border-color 0.15s, background 0.15s;
}
.search-wrapper:focus-within {
  border-color: #5e85ef;
  background: #fff;
}

.search-icon { flex-shrink: 0; }

.search-input {
  flex: 1;
  border: none;
  outline: none;
  background: transparent;
  font-size: 13px;
  color: #334155;
  min-width: 0;
}
.search-input::placeholder { color: #b0bac8; }

.clear-search {
  background: none;
  border: none;
  cursor: pointer;
  padding: 0;
  display: flex;
  align-items: center;
  flex-shrink: 0;
}

/* Table header */
.table-header {
  display: flex;
  align-items: center;
  padding: 0 14px;
  height: 32px;
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px 8px 0 0;
  border-bottom: none;
}

.table-header > div {
  font-size: 11px;
  font-weight: 600;
  color: #94a3b8;
  text-transform: uppercase;
  letter-spacing: 0.05em;
}

/* Column widths */
.col-etapa  { width: 160px; flex-shrink: 0; }
.col-title  { flex: 1; min-width: 0; }
.col-actions { width: 90px; flex-shrink: 0; display: flex; justify-content: flex-end; }

/* Protocols list */
.protocols-list {
  border: 1px solid #e2e8f0;
  border-radius: 0 0 8px 8px;
  overflow: hidden;
  background: #fff;
}

/* Protocol row */
.protocol-row {
  display: flex;
  align-items: center;
  padding: 0 14px;
  height: 40px;
  cursor: pointer;
  border-bottom: 1px solid #f1f5f9;
  transition: background 0.1s;
}
.protocol-row:last-child {
  border-bottom: none;
}
.protocol-row:hover {
  background: #f8fafc;
}

/* Etapa badge */
.etapa-badge {
  display: inline-block;
  font-size: 11px;
  font-weight: 600;
  color: #5e85ef;
  background: #eff4ff;
  padding: 2px 9px;
  border-radius: 10px;
  letter-spacing: 0.01em;
  white-space: nowrap;
  max-width: 140px;
  overflow: hidden;
  text-overflow: ellipsis;
}

/* Protocol title */
.protocol-title {
  font-size: 13px;
  color: #334155;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  display: block;
}

/* Edit button */
.btn-edit {
  display: inline-flex;
  align-items: center;
  gap: 5px;
  height: 26px;
  padding: 0 10px;
  border-radius: 6px;
  border: 1px solid #e2e8f0;
  background: #fff;
  font-size: 12px;
  font-weight: 500;
  color: #475569;
  cursor: pointer;
  opacity: 1;
  transition: all 0.15s;
}
.btn-edit:hover {
  background: #5e85ef;
  border-color: #5e85ef;
  color: #fff;
}

/* Empty state */
.empty-state {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 48px 20px;
  gap: 6px;
}
.empty-title {
  margin: 4px 0 0;
  font-size: 13px;
  font-weight: 600;
  color: #64748b;
}
.empty-sub {
  margin: 0;
  font-size: 12px;
  color: #94a3b8;
  text-align: center;
}

/* Pagination */
.pagination-wrapper {
  display: flex;
  justify-content: center;
  padding: 16px 0 4px;
}
</style>